export default __webpack_public_path__ + "static/media/bank-pro.24c82950.png";